import * as yup from "yup";

const SIGN_UP_STEP_IDS = [
  "profile",
  "verify-email",
  "microphone",
  "preview",
  "trust",
] as const;

export type SignUpStepId = (typeof SIGN_UP_STEP_IDS)[number];

export const SignUpStepIdSchema = yup
  .mixed()
  .oneOf([...SIGN_UP_STEP_IDS])
  .required() as yup.Schema<SignUpStepId>;
